import { request } from '../api/request'
import { GlobalConfig } from '../config'

/**
 * 同步秒杀服务器时间
 * @return {number} 当前时间戳
 */
export const syncServerTimeSpike = async () => {
  try {
    const { dateline } = await request.get(
      GlobalConfig.APIs.serverTimeSyncSpike
    )
    return Number(dateline) * 1000
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * 成功回调
 * @callback SuccessFn
 * @param {number} time - 现在的时间戳
 */

/**
 * 失败回调
 * @callback ErrorFn
 * @param {Error} [error] - 错误对象
 */

/**
 * 轮询同步秒杀服务器时间
 * @param {number} gap - 时间间隔
 * @param {SuccessFn} successFn - 成功回调
 * @param {ErrorFn} errorFn - 失败回调
 */
export const syncServerTimeSpikePolling = async (gap, successFn, errorFn) => {
  const timer = {
    value: null,
  }
  const fn = () => {
    timer.value = setTimeout(async () => {
      try {
        const time = await syncServerTimeSpike()
        typeof successFn === 'function' && successFn(time)
        fn()
      } catch (error) {
        typeof errorFn === 'function' && errorFn(error)
        fn()
      }
    }, gap)
  }
  fn()
  const time = await syncServerTimeSpike()
  typeof successFn === 'function' && successFn(time)
  return timer
}
